export const globalTickStyles = {
  fontFamily: 'Poppins',
  fontSize: 12,
  fontColor: '#737680',
  lineHeight: 1.6,
}
export const globalLegendConfiguration = {
  display: true,
  position: 'bottom',
  labels: {
    boxWidth: 16,
    padding: 30,
    fontSize: 12,
    fontColor: '#737680',
    fontFamily: 'Poppins',
    filter: (item, chart) => !item.hidden,
  },
}

export const globalTooltipConfig = {
  titleSpacing: 6,
  xPadding: 20,
  yPadding: 20,
  textAlign: 'left',
  backgroundColor: '#16234C',
  titleFontColor: '#ffffff',
  titleFontSize: 12,
  titleFontFamily: 'Poppins',
  titleFontStyle: 'normal',
  titleAlign: 'center',
  bodyFontColor: '#ffffff',
  bodyFontSize: 12,
  bodyFontFamily: 'Poppins',
  bodyFontStyle: 'normal',
  mode: 'index',
  callbacks: {
    title: function (tooltipItems) {
      return tooltipItems[0].xLabel
    },
  },
}
